// TODO: rename this file following the convention (abstract-element.js)
import { constants } from "@config";

export default class AbstractElement {
  constructor () {
    // UI element id
    this.uuid = INKIVE.Math.generateUUID();
  }

  setValues (values) {
    if (values === undefined) return;

    for (const key in values) {
      const newValue = values[key];

      if (newValue === undefined) {
        console.warn('INKIVE.AbstractObject: \'' + key + '\' parameter is undefined.');
        continue;
      }

      if (key in this) {
        this[key] = newValue;
      }
    }

    return this;
  }

  resetFontDecoration () {
    if (!this.font_family) {
      return;
    }

    const fontData = INKIVE.FontsFactory.get(this.font_family);

    if (fontData) {
      let supportsBold = fontData.support.bi || fontData.support.b;
      const supportsItalic = fontData.support.bi || fontData.support.i;

      const fontWeight = parseInt(this.font_weight);

      this.font_weight = isNaN(fontWeight) ? this.font_weight : fontWeight;

      if (!supportsBold && fontData.support && fontData.support.variants) {
        supportsBold = fontData.support.variants.some(variant => Number(variant) > 400);
      }

      this.font_weight = supportsBold || this.font_weight < 400 ? this.font_weight : 'normal';
      this.font_style = supportsItalic ? this.font_style : 'normal';
    }
  }

  calculateOrderedEntryWidth (order, fontSize, orderedWidth, orderedLevel, orderedStyle) {
    if (orderedWidth) {
      return orderedWidth;
    }

    if (order) {
      // In order to estimate the required space between a text and its order value (e.g. 1- text)
      // we assume that a character occupies 60% of its font size
      // this estimation doesn't have to be precise but consistent
      const numberStyle = constants.text.orderedList.styles[orderedStyle]?.symbols[orderedLevel - 1] || 'numbers';
      const averageCharacterWidth = /* 60% */ 0.6 * fontSize;
      const minimumNumberOfCharacters = 3; // 2 digits + 1 mark
      return numberStyle.includes('roman')
        ? minimumNumberOfCharacters * averageCharacterWidth
        : Math.max(String(order).length + 1, minimumNumberOfCharacters) * averageCharacterWidth;
    }
    return 0;
  }
}
